import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import "../scss/dataAnalytics.scss";
import { Button } from 'reactstrap'
import { IDropdownOptionsModel } from '../../../models/CommonFields';
import { config_dict } from '../../../helpers/ModelHelpers';
import { faCheck, faCheckDouble, faClipboard, faCopy, faRotateRight, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import SearchableDropdown from '../../../commonfields/SearchableDropdown';

interface IExtractedDataListProps {
    extractedData: any; 
    extractedModal: boolean;
    toggleExtractedModal?: () => void;
    saveExtractedData: Function;
  }

const ExtractedDataFrame = (props: IExtractedDataListProps) => {
    
const { extractedData, saveExtractedData } = props;
    // states
  const [ modifiedData, setModifiedData ] = useState<any>([]);
  const [ extractedSearch, setExtractedSearch] = useState("");
  const [ tempOptions, setTempOptions ] = useState<any>([]);

  // constants
  const modifiedDefault = useMemo(() => {
    if (extractedData && extractedData?.length > 0) {
      return extractedData?.map((each2: any) => ({
          label: each2,
          values: []
        }))
    } else return []
  }, [extractedData])

  // map for fields
  const extractedDataMap = useCallback((value: string) => {
    if (extractedData && extractedData?.length > 0) {
      return extractedData?.filter((fil: any) => fil !== value)?.map((each: any) => ({
        value: each,
        label: each,
      }))
    } else return []
  }, [extractedData])

  // helpers
  const handleDropdownChange = (item: IDropdownOptionsModel, labelValue: string) => {
    const newValues = modifiedData?.map((each: any) => {
      if (each?.label === labelValue) {
        return ({ ...each, values: item })
      } else return each
    })
    setModifiedData(newValues)
  }

  const copySelected = (value: string) => {
    setTempOptions(modifiedData?.find((each: any) => each?.label === value)?.values || [])
  }

  const replacePrevious = (value: string) => {
    setModifiedData((prev: any) => {
      if (prev && prev?.length) {
        return prev?.map((each: any) => {
          if ( each?.label === value) {
            return ({ ...each, values: tempOptions })
          } else return each
        })
      } else return []
    })
  }

  const selectAll = (value: string) => {
    setModifiedData((prev: any) => {
      if (prev && prev?.length) {
        return prev?.map((each: any) => {
          if ( each?.label === value) {
            return ({ ...each, values: extractedData?.map((each2: any) => ({ value: each2, label: each2 })) })
          } else return each
        })
      } else return []
    })
  }

  const removeSelected = (value: string) => {
    setModifiedData((prev: any) => {
      if (prev && prev?.length) {
        return prev?.filter((each: any) => each?.label !== value)
      } else return []
    })
  }

  const setDefault = () => {
    const keys = Object.keys(config_dict);
    setModifiedData(keys?.map(each => ({
      label: each,
      values: config_dict?.[each]?.map((val: any) => ({ value: val, label: val }))
    })))
  }

  // useEffects
  useEffect(() => {
    setModifiedData(modifiedDefault)
  }, [modifiedDefault])

  // display functions
  const displayModifiedData = useCallback(() => { 
    return modifiedData && modifiedData?.length > 0 ? 
      modifiedData
      ?.filter((val: any) => val?.label?.toLocaleLowerCase()?.includes(extractedSearch?.toLocaleLowerCase()))
      ?.map((each: any) => 
        <div className="extracted-item" key={each?.label}>
          <div className="label">
            <div className="text">{each?.label}</div>
            <div className="other-options">
              { each?.values && each?.values?.length > 0 ? 
              <div className="copy" onClick={() => copySelected(each?.label)}>
                <FontAwesomeIcon icon={faCopy} />
              </div> : <></>}
              <div className="delete" onClick={() => removeSelected(each?.label)}>
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
          <div className="dropdown">
            <SearchableDropdown
              value={each?.values}
              handleChange={handleDropdownChange}
              options={extractedDataMap(each?.label)}
              classNamePrefix='extractedSearch'
              isMulti={true}
              labelValue={each?.label}
              placeholder='Select nodes'
            />
          </div>
          <div className="other-options right">
            { tempOptions && tempOptions?.length > 0 ? 
            <div className="prev-copy" onClick={() => replacePrevious(each?.label)}>
              <FontAwesomeIcon icon={faClipboard} /> 
              {/* Prev Saved */}
            </div> : <></>}
            <div className="select-all" onClick={() => selectAll(each?.label)}>
            <FontAwesomeIcon icon={faCheckDouble} /> 
              {/* Select All */}
            </div>
          </div>
        </div>
      ) 
      : <div className="not-found">No data available</div> 
  }, [modifiedData, tempOptions, extractedSearch])
  return (
    <>
     <div className="title-row">
        <div className="search-box">
          <input
            type="text"
            className="search-input"
            placeholder="Search"
            value={extractedSearch}
            onChange={(e) => setExtractedSearch(e?.target?.value)}
          />
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
        </div>
        <div className="temp-btns">
          <Button className='attr-add-btn' onClick={setDefault}>Set Default</Button>
          <Button 
            outline 
            onClick={() => {
              setModifiedData(modifiedDefault)
              setTempOptions([])
            }}
            className='attr-add-btn reset'
          >
           <FontAwesomeIcon icon={faRotateRight} /> Reset
          </Button>
          <Button 
            className='attr-add-btn'
            onClick={() => saveExtractedData(modifiedData)}
          >
            <FontAwesomeIcon icon={faCheck} /> Create
          </Button>
        </div>
      </div>
        <div className="extracted-list">
          { displayModifiedData() }
        </div>
    </>
  )
}

export default ExtractedDataFrame